import { FC, useState } from 'react';
import {
  IconWrapper,
  Item,
  StyledCollapse,
  StyledListItem,
  StyledListItemText,
  StyledSubListItem,
  Stick,
} from 'containers/AppContainer/SideBar/style';
import { List, ListItemIcon } from '@material-ui/core';
import HomeIcon from 'components/SahamIcons/HomeIcon';
import { translate } from 'containers/services/translate';
import messages from 'containers/AppContainer/messages';
import { history } from 'store';
import { PAGES } from 'routes';
import { IntlShape, injectIntl } from 'react-intl';
import MissionIcon from 'components/SahamIcons/MissionIcon';
import FeeNoteIcon from 'components/SahamIcons/FeeNoteIcon';
import NewSinisterIcon from 'components/SahamIcons/NewSinistersIcon';
import ArrowRightIcon from 'components/SahamIcons/ArrowRightIcon';
import ArrowDownIcon from 'components/SahamIcons/ArrowDownIcon';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import DraftFilesIcon from 'components/SahamIcons/DraftFilesIcon';

const selectedItem = (paths: string[]) => {
  return paths.some(path => path === history.location.pathname);
};

export interface LawyerMenuProps {
  intl: IntlShape;
  pushToAndReset: Function;
  isMenuOpen: boolean;
}

const LawyerMenu: FC<LawyerMenuProps> = (props): JSX.Element => {
  const [subListOpen, setSubListOpen] = useState(false);
  const [subListOpenProvisional, setSubListOpenProvisional] = useState(false);

  const toggleSubListOpen = () => {
    setSubListOpen(!subListOpen);
  };
  const toggleSubListOpenProvisional = () => {
    setSubListOpenProvisional(!subListOpen);
  };
  const { pushToAndReset, isMenuOpen } = props;
  return (
    <List>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.LAWYER_HOME])}
          onClick={pushToAndReset(PAGES.LAWYER_HOME)}
        >
          <ListItemIcon>
            <HomeIcon isActivated />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.sideBarHomeTitle, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>
      <Item>
        <StyledListItem
          data-testid="sub-menu"
          open={isMenuOpen}
          button
          selected={selectedItem([
            PAGES.VALIDATED_CLAIMS,
            PAGES.PENDING_CLAIMS,
            PAGES.REJECTED_CLAIMS,
          ])}
          onClick={toggleSubListOpen}
        >
          <ListItemIcon>
            <NewSinisterIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.newSinistersTitle, props)}
              </span>
            </StyledListItemText>
          )}
          {isMenuOpen ? (
            subListOpen ? (
              <IconWrapper>
                <ArrowDownIcon />
              </IconWrapper>
            ) : (
              <IconWrapper>
                <ArrowRightIcon />
              </IconWrapper>
            )
          ) : null}
        </StyledListItem>
      </Item>
      <StyledCollapse
        in={subListOpen && isMenuOpen}
        timeout="auto"
        unmountOnExit
      >
        <Stick />
        <List component="div" disablePadding>
          <Item>
            <StyledSubListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.VALIDATED_CLAIMS])}
              onClick={pushToAndReset(PAGES.VALIDATED_CLAIMS)}
            >
              {isMenuOpen && (
                <StyledListItemText open={isMenuOpen}>
                  <span className="menuItemText">
                    {translate(messages.sideBarValidatedTitle, props)}
                  </span>
                </StyledListItemText>
              )}
            </StyledSubListItem>
          </Item>
          <Item>
            <StyledSubListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.PENDING_CLAIMS])}
              onClick={pushToAndReset(PAGES.PENDING_CLAIMS)}
            >
              {isMenuOpen && (
                <StyledListItemText open={isMenuOpen}>
                  <span className="menuItemText">
                    {translate(messages.sideBarPendingTitle, props)}
                  </span>
                </StyledListItemText>
              )}
            </StyledSubListItem>
          </Item>
          <Item>
            <StyledSubListItem
              open={isMenuOpen}
              button
              selected={selectedItem([PAGES.MANAGER_REJECTED_CLAIMS])}
              onClick={pushToAndReset(PAGES.REJECTED_CLAIMS)}
            >
              {isMenuOpen && (
                <StyledListItemText open={isMenuOpen}>
                  <span className="menuItemText">
                    {translate(messages.sideBarRejectedTitle, props)}
                  </span>
                </StyledListItemText>
              )}
            </StyledSubListItem>
          </Item>
        </List>
      </StyledCollapse>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.LAWYER_ASSIGNMENTS])}
          onClick={pushToAndReset(PAGES.LAWYER_ASSIGNMENTS)}
        >
          <ListItemIcon>
            <MissionIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <>
              <StyledListItemText open={isMenuOpen}>
                <span className="menuItemText">
                  {translate(messages.sideBarLawyerAssignment, props)}
                </span>
              </StyledListItemText>
            </>
          )}
        </StyledListItem>
      </Item>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.FEE_NOTE])}
          onClick={pushToAndReset(PAGES.FEE_NOTE)}
        >
          <ListItemIcon>
            <FeeNoteIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <>
              <StyledListItemText open={isMenuOpen}>
                <span className="menuItemText">
                  {translate(messages.sideBarFeeNote, props)}
                </span>
              </StyledListItemText>
            </>
          )}
        </StyledListItem>
      </Item>

      {(featureService.hasFeature(FEATURES.COURT_CALENDAR) ||
        featureService.hasFeature(FEATURES.OPENING_BY_USAGE)) && (
        <Item>
          <StyledListItem
            data-testid="sub-menu"
            open={isMenuOpen}
            button
            onClick={toggleSubListOpenProvisional}
          >
            <ListItemIcon>
              <NewSinisterIcon />
            </ListItemIcon>
            {isMenuOpen && (
              <StyledListItemText open={isMenuOpen}>
                <span className="menuItemText">
                  {translate(
                    messages.sideBarCourtMonitoringProvisionalClaims,
                    props,
                  )}
                </span>
              </StyledListItemText>
            )}
            {isMenuOpen ? (
              subListOpenProvisional ? (
                <IconWrapper>
                  <ArrowDownIcon />
                </IconWrapper>
              ) : (
                <IconWrapper>
                  <ArrowRightIcon />
                </IconWrapper>
              )
            ) : null}
          </StyledListItem>
        </Item>
      )}

      <StyledCollapse
        in={subListOpenProvisional && isMenuOpen}
        timeout="auto"
        unmountOnExit
      >
        <Stick />
        <List component="div" disablePadding>
          {featureService.hasFeature(FEATURES.COURT_CALENDAR) && (
            <Item>
              <StyledListItem
                open={isMenuOpen}
                button
                selected={selectedItem([PAGES.PROVISIONAL_CLAIMS])}
                onClick={pushToAndReset(PAGES.PROVISIONAL_CLAIMS)}
              >
                {isMenuOpen && (
                  <>
                    <StyledListItemText open={isMenuOpen}>
                      <span className="menuItemText">
                        {translate(
                          messages.sideBarCourtMonitoringProvisionalClaims,
                          props,
                        )}
                      </span>
                    </StyledListItemText>
                  </>
                )}
              </StyledListItem>
            </Item>
          )}
          {featureService.hasFeature(FEATURES.OPENING_BY_USAGE) && (
            <Item>
              <StyledSubListItem
                open={isMenuOpen}
                button
                selected={selectedItem([PAGES.USAGE_CLAIMS])}
                onClick={pushToAndReset(PAGES.USAGE_CLAIMS)}
              >
                {isMenuOpen && (
                  <StyledListItemText open={isMenuOpen}>
                    <span className="menuItemText">
                      {translate(messages.sideBarUsageClaimsTitle, props)}
                    </span>
                  </StyledListItemText>
                )}
              </StyledSubListItem>
            </Item>
          )}
        </List>
      </StyledCollapse>
    </List>
  );
};

export default injectIntl(LawyerMenu);
